var Emitter = /** @class */ (function () {
    function Emitter() {
        this.events = {};
    }
    Emitter.prototype.on = function (event, fn) {
        this.events[event] = this.events[event] || [];
        this.events[event].push(fn);
    };
    Emitter.prototype.off = function (event, fn) {
        if (this.events[event]) {
            if (!fn) {
                this.events[event] = [];
            }
            else {
                var index = this.events[event].indexOf(fn);
                if (index > -1) {
                    this.events[event].splice(index, 1);
                }
            }
        }
    };
    Emitter.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.events[event]) {
            this.events[event].forEach(function (fn) {
                fn.apply(void 0, args);
            });
        }
    };
    return Emitter;
}());
export { Emitter };
//# sourceMappingURL=emitter.js.map